export {DocUploadComponent} from './doc-upload.component';
export {FileUploadComponent} from './file-upload/file-upload.component';
export * from './types';
